import { bootstrapApplication } from '@angular/platform-browser'
import { RouteReuseStrategy, provideRouter, withComponentInputBinding } from '@angular/router'
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { environment } from 'src/environments/environment'
import { routes } from './app/app.routes'
import { AppComponent } from './app/app.component'
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http'
import { enableProdMode, importProvidersFrom, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core'
import { Amplify } from 'aws-amplify'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import config from './app/modules/config/cognito'
import { authInterceptor } from './app/shared/interceptors/auth.interceptor'
import { errorInterceptor } from './app/shared/interceptors/error.interceptor'
import { provideNgGlyphs, provideNgGlyphsConfig } from '@ng-icons/core'
import { withMaterialSymbolsRounded } from '@ng-icons/material-symbols'
import { registerLocaleData } from '@angular/common'
import localeEsGt from '@angular/common/locales/es-GT'

// import { register } from 'swiper/element/bundle'
// register();

Amplify.configure(config)

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json')

defineCustomElements(window)
if (environment.production) {
  enableProdMode()
}

registerLocaleData(localeEsGt)

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideZonelessChangeDetection(),
    provideIonicAngular(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideHttpClient(),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
    provideNgGlyphs(withMaterialSymbolsRounded()),
    provideNgGlyphsConfig({
      size: 24,
      weight: 400,
      grade: 0,
    }),
    provideIonicAngular({ mode: 'ios', animated: true }),
    { provide: LOCALE_ID, useValue: 'es-GT' },
  ],
})
